module.exports = __webpack_public_path__ + "settings.png?78c255a8d375494e7701eb9bbb98e1b8";